<mat-toolbar
  [ngStyle.sm]="{'margin-bottom.px': -3}"
  [ngStyle.xs]="{'margin-bottom.px': -3}"
  color="primary"
  class="rb-toolbar"
  *ngIf="!hideHeader">
  <div fxLayout="row" fxFlex>
    <div fxLayoutAlign="center center">
      <div class="logo-navbar bar-logo" fxLayout="row" fxLayoutAlign="center center" fxHide.xs>
        <img src="{{env.storage_path+customSettings.logo}}" alt="logo" width="165" height="45" />
        <span class="ps-navbar-name">
          {{clientMainBarService.isInThePortal ? customSettings.title_register_portal : customSettings.title}}
        </span>
      </div>
      <div class="logo-navbar-mobile bar-logo" fxHide.gt-xs fxLayout="row" fxLayoutAlign="center center">
        <img src="{{env.storage_path+customSettings.logo}}" alt="mobile-logo" width="165" height="45"/>
        <span class="ps-navbar-name-mobile">
          {{clientMainBarService.isInThePortal ? customSettings.title_register_portal : customSettings.title}}
        </span>
      </div>
    </div>

    <div fxFlex fxLayoutAlign="end center" fxHide.xs>
      <div *ngIf="!applymentModel.logged">
        <button aria-label="Abrir popup de login" name="Login" mat-raised-button (click)="openLoginDialog()">LOGIN</button>
      </div>
      <div fxLayout="row" fxLayoutAlign="center" *ngIf="applymentModel.logged">
        <button
          name="Nova Inscrição"
          aria-label="Nova inscrição"
          class="new_applyment_button"
          *ngIf="isPortalInscrito()"
          (click)="goToNewApplyment()"
          [style.margin-right.px]="10"
          mat-stroked-button>
          <mat-icon>add</mat-icon>
          Nova inscrição
        </button>
        <button
          name="Menu"
          aria-label="Abrir menu"
          class="ps-client-main-bar-btn-menu"
          mat-button
          [matMenuTriggerFor]="menu">
          <div fxLayout="row" fxLayoutAlign="justify-content center">
            <mat-icon class="person-icon" svgIcon="person-stroke"></mat-icon>
            <span
              [title]="applymentModel.personName"
              class="ps-client-main-bar-btn-menu-text">
              {{applymentModel.personName}}
            </span>
            <mat-icon>arrow_drop_down</mat-icon>
          </div>
        </button>
        <mat-menu #menu="matMenu">
          <button name="Portal do inscrito" aria-label="Portal do inscrito"  mat-menu-item (click)="goToPortalInscrito()">Portal do inscrito</button>
          <button name="Meus Dados"
            aria-label="Meus dados"
            mat-menu-item
            (click)="goToUserDetails()"
            *ngIf="customSettings.user_details_page_id !== null">
            Meus dados
          </button>
          <hr class="ps-client-main-bar-btn-menu-hr">
          <button name="Sair" aria-label="Sair" mat-menu-item (click)="leaveProcess()">Sair</button>
        </mat-menu>
      </div>
    </div>
  </div>
  <button name="Menu" aria-label="Menu" fxHide.gt-xs mat-icon-button (click)="openCloseMenu()">
    <mat-icon>menu</mat-icon>
  </button>
</mat-toolbar>
